var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManulife(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "114px",
    height: "26px",
    viewBox: "0 0 114 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "manulife-english-linear-SVG-RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MARKUPS-for-dev",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "manulife-english-linear-SVG-RGB",
    fill: "#282B3E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6,25.3 L34.6,23.5 C33.7,24.5 32.3,25.7 29.8,25.7 C26.9,25.7 24.6,23.9 24.6,20.8 C24.6,17 28.1,15.6 31.6,15.3 L32.9,15.2 C34.2,15.1 34.7,14.4 34.7,13.5 C34.7,12.4 33.7,11.6 32.1,11.6 C30.3,11.6 28.6,12.9 27.9,13.9 L25.9,11.5 C27.2,9.9 29.4,8.7 32.3,8.7 C36,8.7 38.2,10.6 38.2,13.9 L38.2,25.5 L34.6,25.5 L34.6,25.3 Z M34.6,17.5 L32.1,17.8 C30,18.1 28.1,18.8 28.1,20.6 C28.1,21.9 29.2,22.8 30.6,22.8 C32.3,22.8 33.7,21.7 34.6,20.6 L34.6,17.5 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1,25.3 L41.5,25.3 L41.5,9 L45.1,9 L45.1,10.8 C46.4,9.6 48.3,8.6 50.4,8.6 C52.3,8.6 55,9.7 55,13.7 L55,25.3 L51.4,25.3 L51.4,14.6 C51.4,13 50.7,11.6 49.1,11.6 C47.7,11.6 46,12.8 45.1,13.5 L45.1,25.3 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7,9 L71.3,9 L71.3,25.3 L67.6,25.3 L67.6,23.5 C66.6,24.4 65,25.6 62.9,25.6 C60.8,25.6 57.9,24.5 57.9,20.4 L57.9,9 L61.5,9 L61.5,19.3 C61.5,21.2 62.3,22.5 64,22.5 C65.4,22.5 66.7,21.6 67.7,20.5 L67.7,9 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "78.8 25.3 75.2 25.3 75.2 3.8 78.8 0.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7,1.6 C85.9,1.6 87,2.6 87,3.9 C87,5.2 85.9,6.2 84.7,6.2 C83.4,6.2 82.4,5.1 82.4,3.9 C82.4,2.7 83.4,1.6 84.7,1.6 Z M86.6,25.3 L82.9,25.3 L82.9,9 L86.6,9 L86.6,25.3 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,12 L94.6,12 L94.6,25.4 L91,25.4 L91,12 L88.8,12 L88.8,9 L91,9 L91,5.6 C91,2.9 92.7,0.5 96.1,0.5 C97.7,0.5 99,0.9 99.8,1.3 L98.7,4.1 C98.2,3.8 97.4,3.5 96.7,3.5 C95.6,3.5 94.6,4.3 94.6,5.8 L94.6,9 L98.9,9 L98,12 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.3,18.1 C102.3,20.7 104.2,22.6 106.5,22.6 C108.2,22.6 110,21.5 110.7,20.1 L113,22.2 C111.7,24.1 109.1,25.7 106.2,25.7 C101.5,25.7 98.6,22.2 98.6,17.1 C98.6,12.2 101.7,8.5 106.3,8.5 C110.6,8.5 113.7,11.3 113.5,18 L102.3,18.1 Z M109.6,15.4 C109.6,13.4 108.3,11.5 106.1,11.5 C104,11.5 102.4,13.5 102.3,15.4 L109.6,15.4 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "4 25.3 0 25.3 0 2.6 4.2 2.6 11 13.8 11 13.8 17.6 2.6 21.8 2.6 21.8 25.3 17.8 25.3 17.8 9.3 17.7 9.3 10.8 20.7 4 9.3 4 9.3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManulife);
export default __webpack_public_path__ + "static/media/manulife.475fd739a51136c4beae099abf29772e.svg";
export { ForwardRef as ReactComponent };